const COURSE_STEP_NUMBERS = {
  REGISTRATION: 1,
  STUDING: 2,
  EXAM: 3,
  PASSED: 4,
};

function hasPendingQuestionnaire(examItem) {
  const originExam = examItem && examItem.originExam;
  return originExam && originExam.hasPendingQuestionnaire === true;
}

function resolveCourseDetailStep({
  displayStep,
  routeStep,
  hasPendingQuestionnaire: hasPending,
}) {
  return resolveCourseDetailNavigation({
    displayStep,
    routeStep,
    hasPendingQuestionnaire: hasPending,
  }).currentStep;
}

function resolveCourseDetailNavigation({
  displayStep,
  routeStep,
  hasPendingQuestionnaire: hasPending,
  optionalExamReady = false,
}) {
  if (hasPending) {
    return {
      currentStep: COURSE_STEP_NUMBERS.EXAM,
      maxReachedStep: COURSE_STEP_NUMBERS.EXAM,
    };
  }

  const serverStep =
    COURSE_STEP_NUMBERS[displayStep] || COURSE_STEP_NUMBERS.REGISTRATION;
  const maxReachedStep = optionalExamReady
    ? Math.max(serverStep, COURSE_STEP_NUMBERS.EXAM)
    : serverStep;

  const parsedRouteStep = Number.parseInt(routeStep, 10);
  const currentStep =
    parsedRouteStep >= COURSE_STEP_NUMBERS.REGISTRATION &&
    parsedRouteStep <= maxReachedStep
      ? parsedRouteStep
      : serverStep;

  return { currentStep, maxReachedStep };
}

function hasCertificateEligibility(detailInfo) {
  const certificates =
    detailInfo && Array.isArray(detailInfo.cert) ? detailInfo.cert : [];
  if (certificates.length > 0) {
    return true;
  }

  const exams =
    detailInfo && Array.isArray(detailInfo.exam) ? detailInfo.exam : [];
  return exams.some(
    (examItem) =>
      examItem && examItem.originExam && examItem.originExam.certPass === true
  );
}

function resolveOptionalCourseTarget(detailInfo) {
  if (detailInfo && detailInfo.hasPendingQuestionnaire === true) {
    return COURSE_STEP_NUMBERS.EXAM;
  }

  return hasCertificateEligibility(detailInfo)
    ? COURSE_STEP_NUMBERS.PASSED
    : COURSE_STEP_NUMBERS.EXAM;
}

function getOptionalCourseActionText(examItem) {
  return examItem && examItem.step === "PASSED" ? "查看结果" : "去考试";
}

function isOptionalCourseActionAvailable(
  examItem,
  { isUpcoming = false } = {}
) {
  const baseAvailable =
    examItem &&
    examItem.state === "REGISTERED" &&
    examItem.optionCourseExam === true &&
    examItem.auditStatus === "APPROVED";
  if (!baseAvailable) {
    return false;
  }

  if (examItem.step === "PASSED") {
    return true;
  }

  return examItem.needCam !== true && !isUpcoming;
}

function isExamActionDisabled(examItem) {
  const originExam = examItem && examItem.originExam;
  const originExamNeedCam = originExam && originExam.needCam;
  const hasRetryTimes =
    examItem &&
    examItem.maxRetryTimes !== undefined &&
    examItem.maxRetryTimes !== null &&
    examItem.maxRetryTimes > 0;

  if (hasPendingQuestionnaire(examItem)) {
    return false;
  }

  if (hasRetryTimes) {
    return (
      originExamNeedCam === true || (examItem && examItem.status === false)
    );
  }

  if (examItem && examItem.examPass) {
    return true;
  }

  const studentExamStatus =
    (examItem && examItem.studentExamStatus) ||
    (originExam && originExam.status);
  if (
    studentExamStatus === "done" ||
    studentExamStatus === "graded" ||
    studentExamStatus === "terminated"
  ) {
    return true;
  }

  return originExamNeedCam === true || (examItem && examItem.status === false);
}

function getExamButtonText(examItem) {
  if (hasPendingQuestionnaire(examItem)) {
    return "去填写问卷";
  }

  if (examItem && examItem.originExam && examItem.originExam.needCam) {
    return "当前考试不支持使用手机考试";
  }

  const maxRetryTimes = examItem && examItem.maxRetryTimes;
  if (
    maxRetryTimes !== undefined &&
    maxRetryTimes !== null &&
    maxRetryTimes > 0
  ) {
    return `去考试（剩余考试机会${maxRetryTimes}次）`;
  }

  if (examItem && examItem.examPass) {
    return "已考完";
  }

  if (
    maxRetryTimes !== undefined &&
    maxRetryTimes !== null &&
    maxRetryTimes <= 0
  ) {
    return "已考完";
  }

  return "去考试";
}

module.exports = {
  getExamButtonText,
  getOptionalCourseActionText,
  hasCertificateEligibility,
  hasPendingQuestionnaire,
  isExamActionDisabled,
  isOptionalCourseActionAvailable,
  resolveCourseDetailNavigation,
  resolveCourseDetailStep,
  resolveOptionalCourseTarget,
};
